require('./GridItemFilter.scss');

const {t} = require('services/i18nextWrapper');

const React = require('react'),
    {PropTypes} = require('react'),
    TextField = require('components/Commons/TextField/TextField');

const GridItemFilter = React.createClass({displayName: "GridItemFilter",
    propTypes: {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onEnter: PropTypes.func,
        value: PropTypes.func
    },

    render() {
        const {onChange, onBlur, onEnter, value} = this.props;
        return (
            React.createElement("div", {className: "bp-grid-item-filter should-focus"}, 
                React.createElement(TextField, {
                    ref: ref => (this._el = ref), 
                    icon: "search", 
                    floatingLabelStyle: {
                        color: '#fff !important',
                        fontWeight: '200'
                    }, 
                    LabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    onChange: onChange, 
                    onBlur: onBlur, 
                    onEnterKeyDown: onEnter, 
                    floatingLabelText: t('filter_icon'), 
                    value: value, 
                    style: {
                        width: '100%',
                        fontWeight: '300'
                    }}
                )
            )
        );
    }
});

module.exports = GridItemFilter;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/GridItem/GridItemFilter.js
 **/